import React from 'react';

const s = {
  wrap: { maxWidth: '980px' },
  back: { color: '#3A6BA8', fontSize: '13px', cursor: 'pointer', marginBottom: '16px', display: 'inline-block' },
  h2: { fontSize: '20px', margin: '0 0 5px', color: '#154D97', letterSpacing: '.01em' },
  sub: { color: '#3A6BA8', fontSize: '13.5px', margin: '0 0 22px' },
  paths: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px' },
  path: { background: '#fff', border: '1px solid #C5D5EA', borderRadius: '11px', padding: '22px', display: 'flex', flexDirection: 'column' },
  pathPick: { border: '2px solid #154D97' },
  tag: { fontSize: '10px', letterSpacing: '.08em', textTransform: 'uppercase', fontWeight: 700, color: '#154D97', background: '#EAF1FA', borderRadius: '11px', padding: '3px 10px', alignSelf: 'flex-start', marginBottom: '12px' },
  tagAlt: { color: '#3A6BA8', background: '#F0F5FC' },
  h3: { fontSize: '16.5px', margin: '0 0 7px', color: '#0D2545' },
  p: { fontSize: '13px', color: '#3A6BA8', margin: '0 0 15px', lineHeight: 1.6 },
  drop: { border: '2px dashed #7EA3D7', borderRadius: '10px', background: '#F7FAFE', padding: '28px 18px', textAlign: 'center', marginBottom: '13px' },
  dropBig: { fontSize: '14px', fontWeight: 600, color: '#154D97' },
  dropSmall: { fontSize: '12px', color: '#8A94A6', marginTop: '5px' },
  list: { border: '1px solid #C5D5EA', borderRadius: '10px', background: '#fff', padding: '16px 18px', marginBottom: '13px', fontSize: '12.5px', color: '#3A6BA8', lineHeight: 1.95 },
  types: { fontSize: '11.5px', color: '#8A94A6', marginBottom: '15px' },
  btn: { background: '#154D97', border: '1px solid #154D97', color: '#fff', borderRadius: '8px', padding: '12px 18px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginTop: 'auto', width: '100%' },
  btnGhost: { background: '#fff', border: '1px solid #C5D5EA', color: '#154D97' },
  btnOff: { background: '#F0F5FC', border: '1px solid #DCE7F5', color: '#A8B4C4', cursor: 'not-allowed' },
  soon: { fontSize: '11.5px', color: '#8A5A12', background: '#FAEEDA', border: '1px solid #E8D4AC', borderRadius: '8px', padding: '9px 12px', marginTop: '11px' },
};

export default function StartDeal({ onBlank, onCancel }) {
  return (
    <div style={s.wrap}>
      {onCancel && <div style={s.back} onClick={onCancel}>&#8592; Back to deals</div>}
      <h2 style={s.h2}>Start a new deal</h2>
      <p style={s.sub}>Two ways in. Either one lands you in the full deal screen, and nothing saves until you press Save.</p>

      <div style={s.paths}>
        <div style={{ ...s.path, ...s.pathPick }}>
          <span style={s.tag}>Fastest</span>
          <h3 style={s.h3}>Start from documents</h3>
          <p style={s.p}>Drop in whatever the borrower or broker sent. Claude reads it and fills what it can find, then you check its work before anything saves.</p>
          <div style={s.drop}>
            <div style={s.dropBig}>Drop files here</div>
            <div style={s.dropSmall}>or click to browse</div>
          </div>
          <div style={s.types}>Deal summaries, emails, 1003s, term sheets, paystubs, bank statements, purchase contracts, credit reports.</div>
          <button style={{ ...s.btn, ...s.btnOff }} disabled>Read the documents</button>
          <div style={s.soon}>Not wired up yet. The reading engine is the next build. Use Start by hand for now.</div>
        </div>

        <div style={s.path}>
          <span style={{ ...s.tag, ...s.tagAlt }}>Full control</span>
          <h3 style={s.h3}>Start by hand</h3>
          <p style={s.p}>Go straight into the deal with every section open. Loan and property, all four borrowers, income, assets, real estate, liabilities. Nothing is gated and nothing is skipped.</p>
          <div style={s.list}>
            Loan / Property<br />
            Borrower / sponsor<br />
            Income &amp; Employment<br />
            Assets, Real estate owned, Liabilities
          </div>
          <div style={s.types}>You can still drop documents in later from the Documents section.</div>
          <button style={{ ...s.btn, ...s.btnGhost }} onClick={onBlank}>Open a blank deal</button>
        </div>
      </div>
    </div>
  );
}
